export const queryKeys = {
  user: "user",
  users: "users",
  category: "category",
  post: "post",
  comment: "comment",
};
